import { Box, Image } from '@mantine/core';
import React from 'react';

const AssetsLogin = () => {
  return (
    <>
      <Box pos={'absolute'} top={0} right={0}>
        <Image
          src='/assets/login_assets-01.svg'
          height={150}
          style={{ borderTopRightRadius: '2rem' }}
        />
      </Box>
      <Box pos={'absolute'} top={150} left={0}>
        <Image src='/assets/login_assets-02.svg' />
      </Box>
      <Box pos={'absolute'} bottom={24} right={30}>
        <Image src='/assets/login_assets-03.svg' height={240} />
      </Box>
    </>
  );
};

export default AssetsLogin;
